/** WEB WORKER FUNCTION TO DISPATCH THE REPORT API CALLS */
/* TO-DO Error Handling */


/**
 * @param {*} path path for the report, eg: reports/debitcharge/
 * @param {*} queryWithPagination query params
 * @param {*} pageCount page count per request
 * @param {*} token JWT - Bearer token, since the api call is not in the source module all the headers should be passed separately
 */
export const getReportData = async (URL_BASE_API, path, queryWithPagination, token,unid) => {
    const params = new URLSearchParams(queryWithPagination);
    const current_practice_id = params.get('practice_pk');
    if (current_practice_id) {
        queryWithPagination += '&current_practice_id=' + current_practice_id;
    }

    const url = URL_BASE_API + path + queryWithPagination;
    const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        Unid: unid,
    };
    fetch(url, { headers })
        .then((response) => {
            
            if (!response.ok) {
                throw new Error(response.status === 401 && response.statusText === "Unauthorized"? 'Session Out Error': response.status === "error");
                
            }
            return response.json();
        })
        .then((data) => {
            postMessage({ type: 'success', isJson: true, data });
        })
        .catch((error) => {
          
            postMessage({ type: 'error', error: error.message || 'error' , URL_BASE_API, path, queryWithPagination  });
        });
};

/**
 * getXLS function as web worker
 * @param {*} path 
 * @param {*} queryWithPagination 
 * @param {*} token 
 * @returns 
 */
export const getXLS = async(URL_BASE_API, path, queryWithPagination, token,unid) => {
    const params = new URLSearchParams(queryWithPagination);
    const current_practice_id = params.get('practice_pk');
    if (current_practice_id) {
        queryWithPagination += '&current_practice_id=' + current_practice_id;
    }

    const url = URL_BASE_API + path + queryWithPagination;
    const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        Unid: unid,
    };
    const options = {
        method: "GET",
        headers: headers,
        responseType: "blob",
    };
    try {
        const response = await fetch(url, options);
        if (response.ok) {
            const blob = await response.blob();
            const contentDisposition = response.headers.get("content-disposition");
            return { type: "success", blob, contentDisposition };
        } else {
            throw new Error(response.status === 401 && response.statusText === "Unauthorized"? 'Session Out Error': response.status === "error");
        }
    } catch (error) {
        postMessage({ type: "error", error: error.message  || 'error' , URL_BASE_API, path, queryWithPagination  });
        return null;
    }
};